// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1831":"4cd17ca6","3035":"52044d10","5618":"6f2bf078"}[chunkId] + ".chunk.css";
};